import { FC, useEffect } from "react";

const normaliseTwitterUrl = (url: string) =>
  url.replace(/^https?:\/\/(www\.)?x\.com/, "https://twitter.com");

interface Props {
  url?: string;
}

const Tweet: FC<Props> = ({ url }) => {
  const tweetUrl = url ? normaliseTwitterUrl(url) : undefined;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  if (!tweetUrl) {
    return null;
  }

  return (
    <blockquote className="twitter-tweet">
      <a href={tweetUrl}></a>
    </blockquote>
  );
};

export default Tweet;
